import script from "./ImprovementSuggestions.vue?vue&type=script&setup=true&lang=js"
export * from "./ImprovementSuggestions.vue?vue&type=script&setup=true&lang=js"

import "./ImprovementSuggestions.vue?vue&type=style&index=0&id=0e23115e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e23115e"]])

export default __exports__